import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/mascot/logo-blue.webp")